import { render, staticRenderFns } from "./InputList.vue?vue&type=template&id=2611f82b&scoped=true"
import script from "./InputList.vue?vue&type=script&lang=js"
export * from "./InputList.vue?vue&type=script&lang=js"
import style0 from "./InputList.vue?vue&type=style&index=0&id=2611f82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611f82b",
  null
  
)

export default component.exports